module.exports = __webpack_public_path__ + "static/media/2.09d246cf.jpg";